module.exports = __webpack_public_path__ + "static/transparency-bba39cfbf18febf115f1133fc1bcc02c.svg";